var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"message-box"},[_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.$t('organization_message'))+" ")]),_c('div',{staticClass:"text-right mt-3 font-weight-bold"},[_vm._v(_vm._s(_vm.$t('future_ai_summit_team')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }